<template>
	<BasePage
		class="basePage--login"
		:header-cfg="headerCfg"
		:hasFooter="false"
		:hasHeader="false"
		:wrap-inner="false"
	>
		<template #withoutWrapper>
			<div class="mainContent mainContent--login login-wrapper">
				<LoginSideImage :animate="true" />
				<div class="login-form-wrapper">
					<h1 class="mainHeader-siteName">
						<Logo
							:modifiers="['mooieStraat', 'landscape', 'whiteBg']"
							href="/"
							class="mainHeader-siteNameLink login-form__logo"
							title="Mijn Mooie Straat"
						>
							Mijn Mooie Straat
						</Logo>
					</h1>
					<form action method="POST" class="loginForm">
						<h2
							class="loginForm-title"
						>Het alles-in-één platform voor lokale besturen in de strijd tegen zwerfvuil &amp; sluikstort</h2>
						<InfoBox v-if="appUser" :withIcon="true" class="info-blue">
							Er werd een nieuw account voor je aangemaakt. Inloggen kan je aan de hand van het wachtwoord die je gebruikt voor de mobiele app. Je kan altijd je wachtwoord herstellen via ‘wachtwoord vergeten'.
						</InfoBox>
						<p
							class="loginForm-instruction"
						>Vul je e-mailadres of gebruikersnaam en wachtwoord in om aan te melden.</p>
						<FormItem
							v-model="username"
							id="txtUsername"
							type="text"
							label="E-mailadres of Gebruikersnaam"
							errorVariant="box"
							:modifiers="['fullWidth', 'noGutters']"
						/>
						<FormItem
							v-model="password"
							id="txtPassword"
							type="password"
							label="Wachtwoord"
							errorVariant="box"
							:modifiers="['fullWidth', 'noGutters']"
						/>
						<FormItem
							type="checkbox"
							id="check-all"
							name="check-all"
							label="Ik wil aangemeld blijven."
							:modifiers="['noGutters']"
							@input="onCheckbox"
							:value="rememberLoggedIn"
						/>

						<MessageBox
							ref="loginErrorMsg"
							type="error"
							class="loginForm-errorMessage"
							:message="errorMessage"
						/>

						<div class="form-actions">
							<button
								v-if="!submitted"
								type="submit"
								name="btnLogin"
								class="button button--big button--filled login-submit"
								@click.prevent="onLoginClick"
							>Aanmelden</button>
							<button
								v-else
								type="button"
								name="btnLogin"
								class="button button--filled button--big button--loading login-submit"
							>
								Aanmelden
								<span class="loader"></span>
							</button>
						</div>
						<router-link
							to="/password/reset"
							class="loginForm-serviceLink"
							title="Wachtwoord vergeten?"
						>Wachtwoord vergeten?</router-link>
					</form>

					<div class="login-footer">
						<p class="login-footer__app">
							&copy; Mijn&nbsp;Mooie&nbsp;Straat&nbsp;{{ (new Date()).getFullYear() }}
							<i class="version">{{ appVersion }}</i>
						</p>
						<a
							href="https://mijnmooiestraat.be/algemene-voorwaarden.php"
							class="footerLink footerLink--disclaimer mainFooter-link login-footer__link"
						>Disclaimer</a>
						<img
							alt="logo"
							class="login-footer__logo"
							:src="getImage('logo-patch-white-new.svg', 'logos')"
						/>
					</div>
				</div>
			</div>
		</template>
	</BasePage>
</template>

<script src="./Login.js"></script>
